import { useTranslation } from "react-i18next";

import { Container, Content, CardsContainer } from "./styles";
import { ProjectListComponent } from "./projectListComponent";
import { projectsList_enUS, projectsList_ptBR } from "./projectsListLocales";

export function Projects() {
  const { t, i18n } = useTranslation();

  return (
    <>
      <Container id="projects">
        <Content>
          <p>{t("projects")}</p>

          <span>{t("ThingsIveBuilt")}</span>

          <CardsContainer>
            <ProjectListComponent
              projects={
                i18n.language === "pt-BR"
                  ? projectsList_ptBR
                  : projectsList_enUS
              }
            />
          </CardsContainer>
        </Content>
      </Container>
    </>
  );
}
